export enum MultiSearchWithCheckListItemType {
	ITEM_GROUP_TITLE = 'item_group_title',
	PATIENT = 'patient',
	DEFAULT = 'default',
	TOGGLE_MORE = 'toggle_more',
	DIVIDER = 'divider',
	DOCTOR = 'doctor',
	GROUP = 'group',
	NON_DOCTOR = 'non_doctor',
}
